import { ValueOf } from '../common/utils';

export const BRAND_STATUS_V2 = {
  REQUEST_JOIN: 'requestJoin',
  REJECT: 'reject',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type BRAND_STATUS_V2 = ValueOf<typeof BRAND_STATUS_V2>;
